"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var client_1 = tslib_1.__importDefault(require("./client"));
var industry_1 = tslib_1.__importDefault(require("./industry"));
var address_1 = tslib_1.__importDefault(require("./address"));
var bank_1 = tslib_1.__importDefault(require("./bank"));
var productiontype_1 = tslib_1.__importDefault(require("./productiontype"));
var file_1 = tslib_1.__importDefault(require("./file"));
var ProjectResource = /** @class */ (function (_super) {
    tslib_1.__extends(ProjectResource, _super);
    function ProjectResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectResource.endpoint = '/projects';
    ProjectResource.MODEL_NAME = 'project';
    ProjectResource.related = {
        parent: ProjectResource,
        client: client_1.default,
        industry: industry_1.default,
        address_main: address_1.default,
        address_billing: address_1.default,
        address_contact: address_1.default,
        address_mailing: address_1.default,
        bank: bank_1.default,
        // fees: FeeResource, --circular
        // fee_groups: FeeGroupResource, --circular
        work_addresses: address_1.default,
        production_type: productiontype_1.default,
        contract_type: productiontype_1.default,
        files: file_1.default
    };
    return ProjectResource;
}(base_1.default));
exports.default = ProjectResource;
//# sourceMappingURL=project.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/project.js
// module id = tiTY
// module chunks = 0